import { Reveal } from "../motion/Reveal";
import { GUARANTEE_BADGE_IMG } from "../../data/academyData";

export const Guarantee = () => (
  <section id="guarantee" data-testid="guarantee-section" className="relative py-20 md:py-28 bg-[#08080A] border-t border-white/[0.06]">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <img
          src={GUARANTEE_BADGE_IMG}
          alt="AX Academy guarantee seal"
          className="w-28 h-28 mx-auto mb-6 rounded-full object-cover shadow-[0_0_50px_rgba(234,179,8,0.4)] border border-amber-500/30"
          data-testid="guarantee-badge"
        />
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white">The AX Academy Guarantee</h2>
        <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
          Join today. Explore every resource. Start your consultation with Aradhya. If, within 7 days, you genuinely feel this wasn't worth your investment, reach out and we'll make it right. No lengthy forms. No awkward questions. No hard feelings.
        </p>
        <p className="mt-6 font-heading text-xl text-white italic">A Small Step. A Lasting Return.</p>
      </Reveal>
    </div>
  </section>
);
